import { render, staticRenderFns } from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=template&id=84bbadb6&scoped=true"
import script from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=style&index=0&id=84bbadb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bbadb6",
  null
  
)

export default component.exports